export function formatDistanceToNowStrict(date: Date): string {
  const diffMs = Date.now() - date.getTime();
  if (Number.isNaN(diffMs)) return '';
  const absMs = Math.abs(diffMs);
  const seconds = Math.round(absMs / 1000);
  if (seconds < 60) return `${seconds}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days}d`;
  const months = Math.round(days / 30);
  if (months < 12) return `${months}mo`;
  const years = Math.round(months / 12);
  return `${years}y`;
}
